module.exports = __webpack_public_path__ + "img/logo_p.907ef5a1.png";